import React from 'react';
import { useTranslation } from 'react-i18next';

import Icon from '../icon/Icon';
import { IconType } from '../icon/types';
import TextButton from '../textButton/TextButton';
import styles from './currentLocationButton.module.scss';

type CurrentLocationButtonProps = {
  onClick: () => void;
  disabled?: boolean;
};

const CurrentLocationButton: React.FC<CurrentLocationButtonProps> = ({
  onClick,
  disabled = false,
}) => {
  const { t } = useTranslation('common');
  return (
    <div className={styles.row}>
      <div className={`${styles.icon} ${disabled && styles.disabledIcon}`}>
        <Icon icon={IconType.CURRENT_LOCATION} size="full" />
      </div>
      <TextButton
        onClick={onClick}
        disabled={disabled}
        label={t('campusNavigation.location.label')}
        side={'none'}
        capitalize
      />
    </div>
  );
};

export default CurrentLocationButton;
